





























































import Modal from "../core/Modals/Modal.vue";
import { CorbeilleElement } from "../models/CorbeilleElement";

export default {
    name: "CorbeilleDetailModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        element: CorbeilleElement,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
    },
};
